/**
 * Libellé du numéro d'immatriculation d'une personne morale : SIREN (9 chiffres,
 * l'entité légale — cas des corporates) ou SIRET (14 chiffres, l'établissement).
 * Basé sur la longueur : le champ `numeroSiret` porte l'un ou l'autre selon la
 * nature de la PM.
 */
export const sirenOrSiretLabel = (value?: string | null): 'SIREN' | 'SIRET' => {
  const digits = (value ?? '').replace(/\D/g, '');
  return digits.length === 9 ? 'SIREN' : 'SIRET';
};
